export function disclaimerfooterRender() { return `<div class="footer-disclaimer-container">
    <div class="disclaimer" style="${  this.__$objToStyleMap(this.style)  }">
        ${ this.disImgConfig ? `<div class="disclaimer-icon" style="${  this.__$objToStyleMap(this.imgstyle)  }">
        </div>`:`` }
        <div class="text" ld--elist="click" ld-on-click="onItemClick"></div>
    </div>
</div>`  }